import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { SupervisorGroupsRequest } from '../../../../../models/api-store/supervisor-groups/supervisor-groups.request.model';
import { SpinnerService } from '../../../../../services/spinner/spinner.service';
import { SupervisorGroupsService } from '../../../../../services/api-store/supervisor-groups/supervisor-groups.service';
import { TRUE } from '../../../../../utils/config/const';

@Component({
  selector: 'app-supervisori-create',
  templateUrl: './supervisori-create.component.html'
})
export class SupervisoriCreateComponent {

  formBuilder: FormGroup;
  request:any = {};
  isButtonSaveDisabled:boolean;


  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private spinner: SpinnerService,
    private supervisorGroupsService: SupervisorGroupsService,
    private toastr: ToastrService,
  ) { 
    this.initForm();
  }


  get form(){return this.formBuilder;}
  get formControls() { return this.formBuilder.controls; }

  initForm(){
    this.formBuilder = this.fb.group({
      name: ['',[Validators.required]]
    });
    this.isButtonSaveDisabled = false;
  }

  getValue(){
    let request = new SupervisorGroupsRequest();
    request.name = this.formBuilder.controls['name'].value;
    return request;
  }

  save(){
    this.request = this. getValue();
    this.supervisorGroupsService.create(this.request).subscribe(
      (response) => {
        if(response){
          //Salvato
          this.toastr.success('Creato con successo', 'Crea supervisore');
          this.isButtonSaveDisabled = true;
          this.activeModal.close(response);
        }
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.isButtonSaveDisabled = true;
        this.toastr.error('Si è verificato un errore durante la creazione' , 'Crea supervisore fallita', {
            timeOut: 5000
        });
      }
    );
  }

  clickButtonSave(){
    if(this.formBuilder.status === 'VALID' && this.formBuilder.touched == TRUE){
      this.isButtonSaveDisabled = true;
      this.save();
    }
  }

  clickButtonCancel() {
    this.activeModal.close('CLOSE');
  }
}
